// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2RTap","buttons":"Footer_buttons__1HoFm"};